import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import {
  CssBaseline, CircularProgress, Container, Button, Grid,
  Typography, Card, CardContent, Chip
} from '@mui/material'
import Pagination from '@mui/material/Pagination'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { FormattedMessage, injectIntl } from 'react-intl'
import { AbilityContext } from '../../config/ability-context'
import Api from '../../services/api'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import UpgradeIcon from '@mui/icons-material/Upgrade'
import PaymentIcon from '@mui/icons-material/Payment'
import HistoryIcon from '@mui/icons-material/History'
import { Link } from 'react-router-dom'
import { getBillingHistory } from '../../services/billing.service'
import * as componentActions from '../../redux/actions/organizations'
import './index.css'

const PAGE_SIZE = 20

class BillingHistory extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      events: [],
      totalCount: 0,
      page: 1
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    await this.loadHistory()
  }

  async loadHistory() {
    const { userSession } = this.props
    const hirerId = userSession.user.hirerid
    if (!hirerId) return

    const offset = (this.state.page - 1) * PAGE_SIZE
    this.setState({ loading: true })
    const result = await getBillingHistory(hirerId, PAGE_SIZE, offset)
    if (result && result.data && result.data.data) {
      const data = result.data.data
      this.setState({
        events: Array.isArray(data) ? data : (data.events || []),
        totalCount: data.totalCount || data.totalcount || (Array.isArray(data) ? data.length : 0),
        loading: false
      })
    } else {
      this.setState({ loading: false })
    }
  }

  handlePageChange = async (event, value) => {
    this.setState({ page: value }, async () => {
      await this.loadHistory()
    })
  }

  getEventIcon(eventType) {
    switch (eventType) {
      case 'subscription_event': return <SwapHorizIcon style={{ color: '#2196f3' }} />
      case 'plan_change': return <UpgradeIcon style={{ color: '#9c27b0' }} />
      case 'payment': return <PaymentIcon style={{ color: '#4caf50' }} />
      default: return <HistoryIcon style={{ color: '#757575' }} />
    }
  }

  getEventTypeLabel(eventType) {
    const intl = this.props.intl
    const labels = {
      'subscription_event': intl.formatMessage({ id: 'billing.event.subscription' }),
      'plan_change': intl.formatMessage({ id: 'billing.event.plan.change' }),
      'payment': intl.formatMessage({ id: 'billing.event.payment' })
    }
    return labels[eventType] || eventType
  }

  formatDate(dateStr) {
    if (!dateStr || dateStr === '0001-01-01T00:00:00') return '-'
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  }

  formatCurrency(value) {
    if (value == null) return ''
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl
    const totalPages = Math.ceil(this.state.totalCount / PAGE_SIZE)

    if (Api == null) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='md' style={{ paddingTop: 20 }}>
            <CssBaseline />

            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 20 }}>
              <Grid item>
                <Button
                  component={Link}
                  to={`/${this.props.match.params.lang}/my-plan`}
                  startIcon={<ArrowBackIcon />}
                  color="primary"
                >
                  {intl.formatMessage({ id: 'back' })}
                </Button>
              </Grid>
              <Grid item xs>
                <Typography variant="h5" component="h1">
                  {intl.formatMessage({ id: 'billing.history' })}
                </Typography>
              </Grid>
            </Grid>

            {this.state.events.length === 0 && !this.state.loading && (
              <Card>
                <CardContent style={{ textAlign: 'center', padding: 40 }}>
                  <HistoryIcon style={{ fontSize: 64, color: '#bdbdbd', marginBottom: 16 }} />
                  <Typography variant="body1" color="textSecondary">
                    {intl.formatMessage({ id: 'billing.no.history' })}
                  </Typography>
                </CardContent>
              </Card>
            )}

            {this.state.events.map((event, idx) => (
              <div key={idx} className={`billing-event-item ${(event.eventtype || event.eventType) || ''}`}>
                <div className="billing-event-header">
                  {this.getEventIcon(event.eventtype || event.eventType)}
                  <Chip
                    label={this.getEventTypeLabel(event.eventtype || event.eventType)}
                    size="small"
                    variant="outlined"
                  />
                  <Typography variant="body2" color="textSecondary" style={{ marginLeft: 'auto' }}>
                    {this.formatDate(event.eventdate || event.eventDate)}
                  </Typography>
                </div>

                <Typography variant="body1" style={{ marginLeft: 32 }}>
                  {event.description || '-'}
                </Typography>

                {((event.oldstatus || event.oldStatus) || (event.newstatus || event.newStatus)) && (
                  <Typography variant="body2" color="textSecondary" style={{ marginLeft: 32 }}>
                    {event.oldstatus || event.oldStatus} &rarr; {event.newstatus || event.newStatus}
                  </Typography>
                )}

                {((event.oldplan || event.oldPlan) || (event.newplan || event.newPlan)) && (
                  <Typography variant="body2" color="textSecondary" style={{ marginLeft: 32 }}>
                    {event.oldplan || event.oldPlan} &rarr; {event.newplan || event.newPlan}
                  </Typography>
                )}

                {(event.amount != null) && (
                  <Typography variant="body2" style={{ marginLeft: 32, fontWeight: 600 }}>
                    {this.formatCurrency(event.amount)}
                    {(event.paymentstatus || event.paymentStatus) && (
                      <Chip
                        label={event.paymentstatus || event.paymentStatus}
                        size="small"
                        style={{ marginLeft: 8 }}
                        color={(event.paymentstatus || event.paymentStatus) === 'Pago' ? 'success' : 'error'}
                      />
                    )}
                  </Typography>
                )}

                {(event.changedby || event.changedBy) && (
                  <Typography variant="caption" color="textSecondary" style={{ marginLeft: 32 }}>
                    {intl.formatMessage({ id: 'billing.changed.by' })}: {event.changedby || event.changedBy}
                  </Typography>
                )}

                {(event.reason) && (
                  <Typography variant="caption" color="textSecondary" style={{ marginLeft: 32, display: 'block' }}>
                    {intl.formatMessage({ id: 'billing.reason' })}: {event.reason}
                  </Typography>
                )}
              </div>
            ))}

            {totalPages > 1 && (
              <Grid container justifyContent="center" style={{ marginTop: 20, marginBottom: 20 }}>
                <Pagination
                  count={totalPages}
                  page={this.state.page}
                  onChange={this.handlePageChange}
                  color="primary"
                />
              </Grid>
            )}

          </Container>

          {this.state.loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}

          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification}
          />

        </main>
        <Footer />
      </div>
    )
  }
}

BillingHistory.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(BillingHistory)))

BillingHistory.contextType = AbilityContext
